<template>
    <div class="order-item-card clearfix">
        <div class="card-picture">
            <h-image :src="imageUrl"></h-image>
            <div class="cover"></div>
            <span class="des">{{provider}}专供</span>
            <!-- 是否专供 -->
            <div class="zhicai" v-if="isDirect == true">
                <h-image src="https://front-xps-cdn.xsyx.xyz/2019/11/01/260431903.png"></h-image>
            </div>
        </div>
        <div class="card-info">
            <div class="title ellipsis">{{title}}</div>
            <div class="sub-title">{{subTitle}}</div>
            <div class="pick-time">{{pickUpTime}}提货</div>
            <div class="price">
                <span class="rmb">￥</span>
                <span class="new-price">{{price}}</span> 
                <span class="old-price">￥{{oldPrice}}</span>
            </div>
            <div class="number"><span class="split">x</span>{{count}}</div>
        </div>
    </div>
</template>
<script>
import hImage from '../image/index.vue';
export default {
    name: 'h-order-card',
    components: {
        hImage
    },
    props: {
        imageUrl: String, // 图片链接
        provider: String,//专供提供方
        isDirect: Boolean,//是否直采
        title:String,//商品标题
        subTitle:String,//商品副标题 描述
        pickUpTime:String,//提货时间
        price:[String,Number],//价格
        oldPrice:[String,Number],//被划掉的价格
        count:[String,Number],//商品数量
    }
}
</script>
<style lang="less" scoped>
@import './index.less';
</style>